import CollectionTableFilter from "./collection-table-filter";


const CollectionFilters = {
    Table: CollectionTableFilter,
}

export default CollectionFilters;